import { Directive, Input } from '@angular/core';
import { Chart } from 'chart.js';
import { Router } from '../../../../../node_modules/@angular/router';
import { DashboardWidget } from '../../../viewmodels/dashboard/dashboard-widget';
import { WidgetDataType } from './widget-data-type';

/**
 * Base class for dashboard widgets
 */
@Directive()
export abstract class DashboardWidgetBase {
  private drillDownFilterParams = [];

  @Input() widgetId: string;
  @Input() title: string;

  @Input() dashboardWidget: DashboardWidget;
  @Input() showActions: boolean;
  @Input() sortable: boolean;
  @Input() drillDownRoute: string;
  @Input() drillDownFilters: Map<string, any[]>;

  constructor(private router: Router) { }

  protected drillDownClickEvent(event: any, chart: Chart) {
    const activeElement = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
    if (!activeElement || !activeElement[0] || !this.drillDownFilters) {
      return;
    }

    this.drillDownFilters.forEach((filterValues: any[], filterPropertyName: string) => {
      this.drillDownFilterParams[filterPropertyName] = filterValues[activeElement[0].index];
    });

    this.router.navigate([this.drillDownRoute], { queryParams: this.drillDownFilterParams });
  }

  public get canvasId(): string {
    return 'canvas' + this.dashboardWidget?.dashboardWidgetId || 'canvas';
  }

  protected xAxesCallback = (value: string): string  => {
    if (this.shouldWrapLabel()) {
      return value;
    } else {
      return this.truncateLabel(value);
    }
  };

  protected yAxesCallback = (value: number|string): number => {
    if (Number.isInteger(value)) {
      return value as number;
    }
  };

  protected displayLegend = (): boolean => {
    if (this.dashboardWidget && this.dashboardWidget.widget) {
      const {
        widget: { widgetDataType },
      } = this.dashboardWidget;
      return widgetDataType === WidgetDataType.PlannedMaintenanceImprovements;
    }
    return false;
  };

  private shouldWrapLabel(): boolean {
    if (this.dashboardWidget && this.dashboardWidget.widget) {
      const {
        widget: { widgetDataType },
      } = this.dashboardWidget;
      return widgetDataType === WidgetDataType.PlannedMaintenanceImprovements;
    }

    return false;
  }

  private truncateLabel(value: string): string {
    const trancuted = value.substring(0, 14);
    if (value.length > 14) {
      return `${trancuted}...`;
    }

    return trancuted;
  }
}
